import React from 'react'
import { formatFailReasons } from '../../helpers'

const FailedNotificationLine = ({ item }) => {
  if (!item || !(item.failed_count > 0)) return null
  const reasons = formatFailReasons(item.fail_reasons)
  return (
    <div style={{ color: '#d33', fontSize: 13, marginTop: 4 }}>
      Не отправлено: {item.failed_count}{reasons ? ` (${reasons})` : ''}
    </div>
  )
}

export default FailedNotificationLine
